import StateWarnings from './StateWarnings.jsx';

export default StateWarnings;